"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var BenchmarkBar_1 = __importDefault(require("atomicComponents/organisms/BarGraphs/BenchmarkBar"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var QuoteBenchmark = function (_a) {
    var _b = _a.min, min = _b === void 0 ? 32933 : _b, _c = _a.max, max = _c === void 0 ? 72838 : _c, _d = _a.median, median = _d === void 0 ? 42948 : _d, _e = _a.vendorQuote, vendorQuote = _e === void 0 ? 58447 : _e;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, mb: 1 }, { children: "Pricing Benchmark " })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", lineHeight: "20px" }, { children: "The average cost of HubSpot per year in the Australian market is ARS 67,374, with a range from $1,200 - $539,283. The median amount is $78,745. Benchmark estimates are based on 2,293 verified transactions and invoices from 152 customers in the Australian market." })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(BenchmarkBar_1.default, { min: min, max: max, median: median, mark: vendorQuote, width: 810, height: 186, size: "lg", type: "dollar" }) }))] }));
};
exports.default = QuoteBenchmark;
